export interface ActionType {
    type: string;
    payload?: object;
  }
export interface IBuyRequest {
    userId?: string;
    sourceSystem?: string;
    loadId?: string;
    binRateId?: string;
    amount?: number;
    currency?: Currency;
    carrierId?:string;
    lhlCharges ?: number;
    fsrCharges ?: number;
}


export enum Currency {
    USD = "USD",
    CAD = "CAD"
  }
  export interface IBuyResponse {
    status ?: string;
    message?: string;
}
